import React from "react";

/**
 * @param {String} image - The image of the person
 * @param {String} project - The project the person is working on
 * @param {String} projectColor - The color of the project text
 * @param {String} role - The role of the person in the project
 * @param {String} name - The name of the person
 * @param {String} description - The description of the person
 */
function PersonCard(props) {
  return (
    <div className="person-grid">
      <img src={props.image} alt={props.name} className="person-image" />

      <div className="person-info">
        <h1 className="section-header">{props.name}</h1>

        {(props.project || props.role) && (
          <h2
            className="sub-header"
            style={{ color: props.projectColor || "#333" }}
          >
            {props.project ? props.project + " - " : ""}
            {props.role}
          </h2>
        )}

        <p className="section-text">{props.description}</p>
      </div>
    </div>
  );
}

export default PersonCard;